






















































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  getListCheckExpert,
  submitCheckExpert,
  deleteCheckExpert,
  getScheduleListByIdCheckExpert,
  saveScheduleCheckExpert,
} from "@/serve/expertAppointment/index";
import { selectPeriodTime } from "@/serve/medicalAppointment/plan";
import { Calendar } from "element-ui";
import { uploadImg } from "@/serve/medicalAppointment/institutionManage";
import dayjs from "dayjs";

interface FormData {
  id: any;
  expertName: string;
  expertPosition: string;
  expertImage: string;
  expertSex: string;
  expertIntroduction: string;
  expertAddress: string;
}

@Component({
  name: "expertManagement",
  components: { Calendar },
})
export default class MedicalReport extends Vue {
  public isSetting = false;
  public sources: any = [];
  public form = {
    name: "",
    current: 1,
    size: 10,
  };
  public pagination = {
    siez: 0,
    total: 0,
    current: 0,
  };
  public tableData = [
    {
      id: 1,
      name: "",
    },
  ];
  public itemDialog: any = false;
  public file!: string;
  public formLabelWidth = "120px";
  public formData: FormData = {
    id: null,
    expertName: "",
    expertPosition: "",
    expertImage: "",
    expertSex: "",
    expertIntroduction: "",
    expertAddress: "",
  };
  private rules = {
    expertName: [{ required: true, message: "请输入专家姓名", trigger: "blur" }],
    expertSex: [{ required: true, message: "请选择专家性别", trigger: "blur" }],
    expertPosition: [
      { required: true, message: "请输入专家职称", trigger: "blur" },
    ],
  };
  public companyId = 0;
  public companyName = "";
  public selectedDates: any = [];
  public periodList: any = [];

  public created() {
    this.getReportList();
  }

  public handleDateSelect() {
    return;
  }

  public isSelected(date: any) {
    const formattedDate = this.formatDate(date);
    return this.selectedDates.some((item: any) => item.date === formattedDate);
  }

  public formatDate(date: any) {
    return date.toISOString().split("T")[0];
  }

  public isPastDate(date: any) {
    const formattedDate = this.formatDate(date);
    const targetDate = dayjs(formattedDate).startOf("day");
    const today = dayjs().startOf("day");
    return targetDate.valueOf() < today.valueOf();
  }

  public onSubmit() {
    this.form.size = 10;
    this.form.current = 1;
    this.getReportList();
  }

  public reset() {
    this.form.current = 1;
    this.form.size = 10;
    this.form.name = "";
    this.getReportList();
  }

  public addNew() {
    this.formData = {
      id: null,
      expertName: "",
      expertPosition: "",
      expertImage: "",
      expertSex: "",
      expertIntroduction: "",
      expertAddress: "",
    };
    this.itemDialog = true;
  }

  public async handleAvatarSuccess(res: { file: File }) {
    const imgs = new FormData();
    imgs.append("file", res.file);
    const file = await uploadImg(imgs);
    this.file = file.data;
    this.formData.expertImage = file.data;
  }

  public beforeAvatarUpload(file: { type: string; size: number }) {
    const isJPG = file.type === "image/jpeg";
    const isPNG = file.type === "image/png";
    const isPG = isJPG || isPNG;
    const isLt2M = file.size / 1024 / 1024 < 1;
    if (!isPG) {
      this.$message.error("上传头像图片只能是 JPG/PNG格式!");
    }
    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 2MB!");
    }
    return isPG && isLt2M;
  }

  public getSourceNum(date: any) {
    const formattedDate = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    return source ? source.number : 0;
  }

  public companyNum(date: any) {
    const formattedDate = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    return source ? source.surplus : 0;
  }

  public handleSelect(index: any) {
    const selectedIndex = this.selectedDates[index];
    this.selectedDates[index].companyNum = selectedIndex.periodList.reduce(
      (sum: number, item: { number: any }) => {
        return sum + Number(item.number || 0);
      },
      0
    );
  }

  public isDateAvailable(date: any) {
    const formattedDate = this.formatDate(date);
    return this.sources.some((source: any) => source.date === formattedDate);
  }

  private submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        submitCheckExpert(this.formData).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.itemDialog = false;
            this.form.name = "";
            this.getReportList();
          }
        });
      } else {
        return false;
      }
    });
  }

  public changeEdit(data: any) {
    this.itemDialog = true;
    this.formData = data;
  }

  public changeDelete(data: any) {
    (this as any).$messageBox
      .confirm(`您确定是否删除专家名称为${data.expertName}的这一条数据`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(async () => {
        const params: any = {
          ids: data.id,
        };
        const res = await deleteCheckExpert(params);
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getReportList();
        }
      });
  }

  public toggleDateSelection(date: any) {
    const formattedDate: any = this.formatDate(date);
    const source = this.sources.find((s: any) => s.date === formattedDate);
    const targetDate = dayjs(formattedDate).startOf("day");
    const today = dayjs().startOf("day");

    if (targetDate.valueOf() < today.valueOf()) {
      this.$message("不能给今日以前的日期设置号源！");
      return;
    }

    const periodAddList = this.periodList.map((item: any) => ({
      ...item,
      number: 0,
      periodId: item.id,
    }));
    const selectedData = {
      date: formattedDate,
      daySurPlus: source ? source.surplus : 0,
      companyNum: source ? source.number : 0,
      scheduleId: source ? source.id : -1,
      periodList:
        source && source.periodList.length
          ? source.periodList
          : periodAddList,
    };

    const index = this.selectedDates.findIndex(
      (d: any) => d.date === formattedDate
    );
    if (index !== -1) {
      this.selectedDates.splice(index, 1);
    } else {
      this.selectedDates.push(selectedData);
    }
  }

  public unselectDate(index: number) {
    this.selectedDates.splice(index, 1);
  }

  public clearSelected() {
    this.selectedDates = [];
  }

  public changeSoure(data: any) {
    this.isSetting = true;
    this.companyId = data.id;
    this.companyName = data.expertName;
    this.clearSelected();
    const params = {
      id: data.id,
    };
    getScheduleListByIdCheckExpert(params).then((res: any) => {
      this.sources = res.data;
    });
    const paramsTime = {
      type: 2,
      title: "",
      status: "",
    };
    selectPeriodTime(paramsTime).then((res: any) => {
      this.periodList = res.data;
    });
  }

  public submitData() {
    const params: any = {
      expertId: this.companyId,
      appointmentList: this.selectedDates.map(
        (item: { periodList: any[]; date: any; scheduleId: any }) => {
          const processedPeriodList = item.periodList.map((period) => {
            let id;
            if (period.type === "2") {
              id = null;
            } else {
              id = period.id;
            }
            return {
              id,
              periodId: period.periodId,
              number: Number(period.number),
            };
          });
          return {
            date: item.date,
            id: item.scheduleId,
            periodList: processedPeriodList,
          };
        }
      ),
    };
    saveScheduleCheckExpert(params).then((res: any) => {
      if (res.code === 200) {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        getScheduleListByIdCheckExpert({ id: this.companyId }).then(
          (obj: any) => {
            this.sources = obj.data;
          }
        );
        this.clearSelected();
      }
    });
  }

  public async getReportList() {
    getListCheckExpert(this.form).then((res: any) => {
      this.tableData = res.data.records;
      this.pagination.siez = res.data.size;
      this.pagination.total = res.data.total;
      this.pagination.current = res.data.current;
    });
  }

  public handleSizeChange(val: any): void {
    this.form.size = val;
    this.getReportList();
  }

  public handleCurrentChange(val: any): void {
    this.form.current = val;
    this.getReportList();
  }

  public goBack() {
    this.isSetting = false;
    this.companyId = 0;
    this.companyName = "";
    this.sources = [];
    this.periodList = [];
    this.clearSelected();
    this.getReportList();
  }
}
